(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_bb63470"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('biosx-flexible-media')) {
    customElements.define('biosx-flexible-media', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.breakpoint = window.matchMedia('(max-width: 749px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.videos = [...this.querySelectorAll('video')];
        this.videos.forEach(video => {
          const frame = video.closest('.bm-frame');
          const button = frame.querySelector('.bm-toggle');
          const update = () => {
            button.toggleAttribute('data-playing', !video.paused);
            button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
            button.hidden = video.controls;
          };
          video.addEventListener('play', update, options);
          video.addEventListener('pause', update, options);
          video.addEventListener('ended', update, options);
          video.addEventListener('loadedmetadata', () => {
            if (video.videoWidth && video.videoHeight) frame.style.setProperty('--bm-natural-ratio', video.videoWidth / video.videoHeight);
          }, options);
          button.addEventListener('click', () => {
            if (video.paused) video.play().catch(update);
            else video.pause();
          }, options);
          update();
        });
        this.syncPlayback = () => {
          this.videos.forEach(video => {
            const frame = video.closest('.bm-frame');
            const active = this.breakpoint.matches ? !frame.classList.contains('bm-desktop') : !frame.classList.contains('bm-mobile');
            if (!active) video.pause();
            else if (this.dataset.autoplay === 'true' && !this.reducedMotion.matches) {
              video.muted = true;
              video.play().catch(() => { frame.querySelector('.bm-toggle').hidden = video.controls; });
            } else if (this.reducedMotion.matches) video.pause();
          });
        };
        this.breakpoint.addEventListener('change', this.syncPlayback, options);
        this.reducedMotion.addEventListener('change', this.syncPlayback, options);
        this.syncPlayback();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.videos?.forEach(video => video.pause());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
